import { useEffect, useState } from 'react'
import Table from '../Components/AdminTable.js'
import { Link } from 'react-router-dom'
import { call } from '../Methods.js'
import FormModal from '../Components/FormModal.js'
import { use } from '../Helpers.js'

function Classes () {
  const pageName = 'classes'
  const pageTitle = 'Dərslər'
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}`
  const [updateTable, setUpdateTable] = useState(false)

  useEffect(() => {
    if (updateTable) {
      setUpdateTable(false)
    }
  }, [updateTable])

  const tableSettings = {
    name: '',
    label: '',
    filters: true,
    pagination: true,
    actions: {
      get: async (params = {}) => {
        const classes = await call.forLoggedUser.class.getClasses(params)
        if (classes.success) {
          return classes.data
        }
        return []
      }
    },
    columns: [
      {
        title: '#',
        property: 'rowNumber',
        style: { width: '30px' },
        filter: {
          enabled: false
        }
      },
      {
        title: 'Filial',
        property: ['branchCode','branchName'],
        mutate:(values)=><span title={values[1]}>{values[0]}</span>,
        filter: {
          enabled: true,
          type: 'select',
          name:'branchId',
          dataSource:async ()=> {
            const source = await call.forLoggedUser.branch.getBranches({})
            let data = source.data.map(d => {
              return { value: d.id, text: d.name }
            })
            return data
          }
        },
        style: {width:'15%'},
      },
      {
        title: 'Tarix',
        property: 'date',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'date',
          name: 'date'
        },
        mutate: value => {
          return use.convertDatetimeToShortDate(value)
        }
      },
      {
        title: 'Saat',
        property: ['beginTime', 'endTime'],
        style: { width: '10%' },
        filter: {
          enabled: false,
          type: 'text',
          name: 'timerange'
        },
        mutate: values => {
          return `${use.convertTimeSpanToShortTime(
            values[0]
          )}-${use.convertTimeSpanToShortTime(values[1])}`
        }
      },
      {
        title: 'Qrup',
        property: 'groupName',
        style: { width: '25%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'groupId',
          dataSource: async () => {
            const source = await call.forLoggedUser.group.getGroups({})
            let data = source.data.map(d => {
              return { value: d.id, text: d.name }
            })
            return data
          }
        }
      },
      {
        title: 'Tip',
        property: 'typeName',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'typeId',
          dataSource: async () => {
            const source = await call.forLoggedUser.listOption.getListOptions({
              listName: 'ClassType'
            })
            let data = source.data.map(d => {
              return { value: d.value, text: d.text }
            })
            return data
          }
        }
      },
      {
        title: 'İştirak',
        property: 'attendance',
        style: { width: '10%' },
        filter: {
          enabled: false,
          type: 'text',
          name: 'name'
        },
        mutate:(value)=>{
          return <span className="link">{value}</span>
        }
      },
      {
        title: 'Status',
        property: 'statusName',
        type:'status-label',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'statusId',
          dataSource: async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'class'
            })
            let data = source.data.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
        },
        mutate: value => {
          return value
        }
      },
      {
        title: 'Əməliyyat',
        property: 'id',
        type: 'actions-list',
        operations:(value)=>[
          {
            type:'link',
            name:'Edit',
            title:'Düzəliş',
            link:`${value}`,
            iconType:'path',
            icon:'/Images/Icons/edit.png',
            disablingConditions:[],
          },
          {
            type:'command',
            name:'delete',
            title:'Qeydi sil',
            warning:`Dərsə aid bütün məlumatlar, o cümlədən, \n - Davamiyyət \n məlumatları birdəfəlik silinəcək.`,
            parameters:`{"id":${value},"entity":"class"}`,
            iconType:'path',
            icon:'/Images/Icons/delete.png',
            disablingConditions:[]
          }
        ],
        style: {width:'10%',minWidth: '50px'}
      }
    ],
    addNew: {
      enabled: true,
      url: `/${pageName}/add`,
      title: '+ Əlavə et'
    }
  }

  const formSettings = [
    {
      name: 'class',
      id: '',
      isMain: true,
      label: 'Dərs',
      actions: {
        get: id => call.forLoggedUser.class.getClassById({ id: id }),
        add: call.forLoggedUser.class.addClass,
        edit: call.forLoggedUser.class.updateClass
      },
      formLists:{
Groups:async () => {
            const source = await call.forLoggedUser.group.getGroups({})
            let data = source.data.map(d => {
              return {
                value: d.id,
                text: d.name
              }
            })
            return data
          },
          ClassTypes:async () => {
            const source = await call.forLoggedUser.listOption.getListOptions({
              listName: 'ClassType'
            })
            let data = source.data.map(d => {
              return { value: d.value, text: d.text }
            })
            return data
          },
          Statuses:async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'class'
            })
            let data = source.data.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
      },
      fields: [
        { type: 'hidden', fieldName: 'id', label: '' },
        {
          label: 'Tarix',
          type: 'date',
          fieldName: 'date',
          validationRules: ['required'],
          defaultValue: new Date().toLocaleDateString('az-AZ'),
          col: { sm: 2 },
          // effects:[
          //   {
          //     type:'valueChange', //valueChange, typeChange,visibility, disability, listContentChange,disableTable
          //     fieldName:'weekDay',
          //     checkCondition:(value)=>{
          //       return new Date(value).getDay() || 7
          //     }
          //   }
          // ],
          mutate: value => {
            return new Date(value).toLocaleDateString('az-AZ')
          }
        },
        // {
        //   label: 'Gün',
        //   type: 'select',
        //   fieldName: 'weekDay',
        //   disabled:true,
        //   data: [
        //         { value: 1, text: 'Bazar ertəsi' },
        //         { value: 2, text: 'Çərşənbə axşamı' },
        //         { value: 3, text: 'Çərşənbə' },
        //         { value: 4, text: 'Cümə axşamı' },
        //         { value: 5, text: 'Cümə' },
        //         { value: 6, text: 'Şənbə' },
        //         { value: 7, text: 'Bazar' }
        //   ],
        //   col: { sm: 2 }
        // },
        {
          label: 'Qrup',
          type: 'select',
          fieldName: 'groupId',
          validationRules: ['required'],
          col: { sm: 2 },
          data:'Groups' 
        },
        {
          label: 'Dərsin növü',
          type: 'select',
          fieldName: 'typeId',
          col: { sm: 2 },
          defaultValue: 0,
          data:'ClassTypes' 
        },
        {
          label: 'Başlama',
          type: 'time',
          fieldName: 'beginTime',
          col: { sm: 2 },
          mutate: value => {
            return [undefined,null,''].includes(value)? '':value.substring(0, 5)
          }
        },
        {
          label: 'Bitmə',
          type: 'time',
          fieldName: 'endTime',
          col: { sm: 2 },
          mutate: value => {
            return [undefined,null,''].includes(value)? '':value.substring(0, 5)
          }
        },
        {
          type: 'select',
          fieldName: 'statusId',
          label: 'Status',
          col: { sm: 2 },
          data:'Statuses' 
        },
        {
          label: 'Əlavə qeydlər',
          type: 'textarea',
          fieldName: 'notes',
          col: { sm: 12 }
        },
        {
          type: 'submit',
          label: 'Təsdiq',
          col: { sm: 12 }
        }
      ]
    },
    {
      name: 'attendance',
      id: '',
      label: 'Davamiyyət',
      isMain: false,
      isStandAlone: false,
      actions: {
        get: id => call.forLoggedUser.class.getParticipation({ classId: id }),
        edit: call.forLoggedUser.class.editParticipation
      },
      fields: [
        { type: 'hidden', fieldName: 'classId', label: '' },
        {
          label: 'Tarix',
          type: 'readonly-text',
          fieldName: 'date',
          col: { sm: 4 },
          mutate: value => {
            return use.convertDatetimeToShortDate(value)
          }
        },
        {
          label: 'Qrup',
          type: 'readonly-text',
          fieldName: 'groupName',
          col: { sm: 4 }
        },
        {
          label: 'Təlim / Kurs',
          type: 'readonly-text',
          fieldName: 'courseName',
          col: { sm: 4 }
        },
        {
          label: 'İştirak',
          type: 'input-group-row',
          fieldName: 'participation',
          defaultValue: [],
          multipleRows: true,
          addRowPermission: false,
          removeRowPermission: false,
          defaultRowCountField: 'classesPerWeek',
          col: { sm: 12 },
          rowStyleRules:[
            {
              fieldName:'studentIsActiveInGroup',
              getStyleRule:(value)=>value==0?{backgroundColor:'#ff9696a3'}:{}}
          ],
          rowFields: [
            {
              type: 'hidden',
              fieldName: 'id',
              col: { sm: 0 }
            },
            { type: 'hidden', fieldName: 'studentIsActiveInGroup', col:{sm:0} },
            {
              type: 'hidden',
              fieldName: 'studentId',
              validationRules: ['required'],
              col: { sm: 0 }
            },
            {
              type: 'hidden',
              fieldName: 'classId',
              col: { sm: 0 }
            },
            {
              label: 'İştirakçı',
              type: 'text',
              fieldName: 'studentFullName',
              disabled: true,
              columnWidth:'20%'
            },
            {
              label: 'İştirak',
              type: 'checkbox',
              fieldName: 'attended',
              columnWidth:'10%'
            },
            {
              label: 'Gecikmə (dq.)',
              type: 'number',
              defaultValue:0,
              fieldName: 'latency',
              columnWidth:'15%'
            },
            {
              label: 'Qeydlər',
              type: 'textarea',
              fieldName: 'notes',
              placeholder: 'Qeyd yoxdur',
              columnWidth:'55%'
            }
          ]
        },
        {
          type: 'submit',
          label: 'Təsdiq',
          col: { sm: 12 }
        }
      ]
    }
  ]

  return (
    <div className='page'>
      <h1 className='page-title'>{pageTitle}</h1>
      <Table tableSettings={tableSettings} updateTable={updateTable} />

      <FormModal
        moduleUrl={`/${pageName}`}
        formSettings={formSettings}
        onSubmit={() => setUpdateTable(true)}
      />
    </div>
  )
}

export default Classes
